<template>
  <div
    id="view-switcher"
    class="view-switcher"
    @click="switchView()"
  >
    <p>{{ isPrintTag ? 'ver lotes' : 'ver amostras' }}</p>
    <md-icon :md-src="mode[option].icon" />
    <md-tooltip :md-direction="tooltipDirection">
      Clique para visualizar no modo {{ mode[option].name }}
    </md-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ViewSwitcher',
  props: {
    option: {
      type: String,
      default: 'list'
    },
    tooltipDirection: {
      type: String,
      default: 'bottom'
    }
  },
  data: () => {
    return {
      mode: {
        list: {
          name: 'lista',
          icon: '/static/images/mode-view-list.svg'
        },
        grid: {
          name: 'card',
          icon: '/static/images/mode-view-grid.svg'
        }
      }
    }
  },
  computed: {
    isPrintTag() {
      if (this.$route.name === 'Impressão de Etiquetas - Amostras') {
        return true
      }
      return false
    }
  },
  methods: {
    switchView() {
      this.$emit('switch-view')
    }
  }
}
</script>

<style lang="scss">
  .view-switcher {
    align-items: center;
    display: flex;
    cursor: pointer;
    z-index: 1;

    p {
      margin-right: 1.5em;
      font-weight: 400;
      color: #7a7a7a;
      font-size: 16px;
      margin: auto;
      padding-right: 0.7em;
    }

    .md-icon {
      width: 18px;
      min-width: 18px;
    }
  }
</style>
